import React from 'react';

const AccessDenied = () => {
  return <h1 name="access-denied">Page not available!</h1>;
};

export default AccessDenied;
